export default {
  title: "Miscellaneous",
  content: [
    "A number of abilities that could not be used while inside can now be used while inside.",
    "Hit chance now applies to both spells and physical attacks unless otherwise specified.",
    "Crit chance now applies to both spells and physical attacks unless otherwise specified.",
    "Buff and debuff limit removed.",
    "A disenchant option has been added to the need/greed UI.",
    "Mail between characters on the same account is now instant.",
    "Melee and ranged auto attack now automatically toggle.",
    "The character pane now contains additional information like hit and crit.",
    "Throwing weapons items no longer stack, but lose durability when thrown instead. These throwing weapons can be repaired. Throwing weapons now often also increase the user's stats.",
    "Vendors now sell drinks that restore mana equal to mage’s Conjured Crystal Water.",
    "Vendors now sell food that restores health equal to mage’s Conjured Cinnamon Roll.",
    "All gathering professions can now be learned in Elwynn Forest, Dun Morogh, Teldrassil, Durotar, Mulgore and Tirisfal Glades. This means players no longer have to travel to a Capital City to learn these professions.",
    "Quest log size increased.",
    "Normal, elite and boss target dummies have been added to all major cities.",
    'A "duel as party" option has been added from the character dropdown menu for party leaders. This allows parties to duel each other.',
    "The boats that travel between Ruth'eran Village - Auberdine and Feralas coast - Feathermoon Stronghold now have the Night Elf boat model.",
  ],
};
